import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ParametroFlexService = 
{
    deletarExcelParametroFlex(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametroflex/excel/deletar', 'excelParametroFlexDeletar');
    },
    salvarExcelParametroFlex(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'parametroflex/excel', 'excelParametroFlex');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('parametroflex/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('parametroflex/eventGrid', {});
    }
}

export default ParametroFlexService;